import React from 'react';
import { FormattedMessage } from 'react-intl';
import RecoveryPaymentButtonStyleType from '../RecoveryPaymentButton.types';
import withSelectedMethodContext from '../../../hoc/withSelectedMethodContext';
import { IPaymentMethodChangeButton } from './ChangePaymentMethodButton.types';
import withContext from '../../../hoc/withContext';
import { PROGRESS, SelectPaymentMethodChangeStatus } from '../../../config/config';
import ChangePaymentMethodButton from './ChangePaymentButton.styles';

function PaymentMethodChangeButton(props: IPaymentMethodChangeButton) {
  const handleRecoverPayment = async () => {
    const { setSelectedPaymentMethodChange, setPaymentMethodAndProgressAndNotification } = props;
    if (setSelectedPaymentMethodChange && setPaymentMethodAndProgressAndNotification) {
      setPaymentMethodAndProgressAndNotification('', '', 0, false, PROGRESS.NOT_SELECTED_PAYMENT_METHOD);
      setSelectedPaymentMethodChange(SelectPaymentMethodChangeStatus.CHANGED);
    }
  };

  const { isVisible, className } = props;

  return (
    <>
      {isVisible && (
        <ChangePaymentMethodButton
          className={`${className} change-payment-method-button`}
          onClick={handleRecoverPayment}
          customType={RecoveryPaymentButtonStyleType.PENDING as string}
        >
          <FormattedMessage id="pay.changePaymentMethod" />
        </ChangePaymentMethodButton>
      )}
    </>
  );
}

export default withSelectedMethodContext(withContext(PaymentMethodChangeButton));
